<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-5">
          <lib-page-header page-title="EMPENHO ORÇAMENTÁRIO"
            page-subtitle="EXERCÍCIO: {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            page-change="{{pagTitulo}}" show-change="true" image-title="assets/img/desktop.png">
          </lib-page-header>
        </div>
        <div class="col-md-7">
          <a (click)="voltar()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </a>
          <a [routerLink]="['/empenhos']" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button *ngIf="entidade.id" (click)="imprimir()" class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/printer.png" alt="imprimir" title="Imprimir nota de empenho" height="22"
              width="22">
          </button>
          <button *ngIf="entidade.id && entidade.especie === 'EMO'" data-toggle="modal" data-target="#dialogAnular"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/coins_delete.png" alt="Anular" title="Anular empenho" height="22" width="22">
          </button>
          <button [routerLink]="['/liquidacoes', 'novo', entidade.id]" routerLinkActive="router-link-active"
            *ngIf="entidade.id && podeIncluir('/liquidacoes') && entidade.especie === 'EMO'"
            class="btn btn-sm btn-outline-secondary float-right ml-2" alt="Liquidar" title="Liquidar">
            <img src="assets/img/global/table_money.png" alt="" height="22" width="22">
          </button>
          <button *ngIf="entidadeForm.get('compra').value" data-toggle="modal" data-target="#dialogCompra"
            class="btn btn-sm btn-outline-secondary float-right ml-2">
            <img src="assets/img/global/choose_log_programs.png" alt="compra" title="itens do empenho" height="22"
              width="22">
          </button>
          <button (click)="submitForm()" type="submit" class="btn btn-info float-right mr-4"
            style="font-size: 13px">Salvar empenho</button>
        </div>
      </div>
      <hr class="mt-2 mb-5" />

      <div class="form-row" *ngIf="entidadeForm.get('especie').value === 'EOA'">
        <div class="form-group col-md-2">
          <label for="data_empenho">Data anulação<span class="text-danger">*</span></label>
          <p-calendar id="data_empenho" formControlName="data_empenho" (onBlur)="fichaAutoComplete.atualizar(false)"
            inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true"
            [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
          </p-calendar>
        </div>
        <div class="form-group col-2 offset-2">
          <label for="valor_empenho" class="font-weight-bold">Valor Anulação<span class="text-danger">*</span></label>
          <input unmask="typed" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
            class="form-control text-right font-weight-bold" id="valor_empenho" placeholder="0,00">
        </div>
      </div>

      <div class="row" *ngIf="entidadeForm.get('especie').value === 'EMO'">
        <div class="col-md-9">

          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="180px" imagem="assets/img/money-contract.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="form-group col-2">
                  <label for="numero_empenho" class="font-weight-bold">
                    Empenho Nº:
                  </label>
                  <span class="form-control font-weight-bold text-right" *ngIf="+entidadeForm.get('numero').value > 0">
                    {{("00000" + entidadeForm.get('numero').value).slice(-5) }}
                  </span>
                </div>
                <div class="form-group col-md-3">
                  <label for="compra">Nº Compra</label>
                  <p-autoComplete #compra_ formControlName="compra" [field]="compraAutoComplete.conversor" id="compra"
                    [suggestions]="compraAutoComplete.lista" (completeMethod)="compraAutoComplete.filtrar($event)"
                    inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }" [forceSelection]="true"
                    [autoHighlight]="true" *ngIf="compraAutoComplete">
                    <ng-template let-compra pTemplate="item">
                      {{compra.numero}}/{{compra.exercicio.ano}}
                    </ng-template>
                  </p-autoComplete>
                </div>
                <div class="form-group col-md-3">
                  <label for="data_empenho">Data empenho<span class="text-danger">*</span></label>
                  <p-calendar id="data_empenho" formControlName="data_empenho"
                    (onBlur)="fichaAutoComplete.atualizar(false)" inputStyleClass="form-control" dataType="date"
                    dateFormat="dd/mm/yy" [locale]="ptBR" [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true"
                    [style]="{ width: '100%' }">
                  </p-calendar>
                </div>               
                <div class="form-group col-md-3 offset-1">
                  <label for="contrato">Contrato</label>
                  <p-autoComplete formControlName="contrato" [field]="contratoAutoComplete.conversor"
                    [suggestions]="contratoAutoComplete.lista" (completeMethod)="contratoAutoComplete.filtrar($event)"
                    placeholder="Nº Contrato" inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }"
                    (onSelect)="contratoAutoComplete.atualizar(true)" (onBlur)="contratoAutoComplete.atualizar(true)"
                    [forceSelection]="true" [autoHighlight]="true" *ngIf="contratoAutoComplete">
                    <ng-template let-contrato pTemplate="item">
                      {{contrato.numero}} <span
                        *ngIf="contrato.aditivo !== null && contrato.aditivo > 0 ">{{contrato.aditivo}}</span>
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>

              <div class="form-row">
                <div class="form-group col-md-2">
                  <label for="processo">N˚ Processo</label>
                  <input formControlName="processo" type="text" class="form-control" id="processo">
                </div>
                <div class="form-group col-md-3">
                  <label for="tipo_empenho">Tipo Empenho<span class="text-danger">*</span></label>
                  <select [compareWith]="compareFn" formControlName="tipo_empenho" id="tipo" class="form-control">
                    <option *ngFor="let item of listaTipos" [value]="item.id">{{item.nome}}</option>
                  </select>
                </div>

                <div class="form-group col-md-3">
                  <label for="data_vencimento">Previsão Pagto</label>
                  <p-calendar #data_vencimento_ id="data_vencimento" formControlName="data_vencimento"
                    inputStyleClass="form-control" dataType="date" dateFormat="dd/mm/yy" [locale]="ptBR"
                    [showIcon]="true" [showOnFocus]="false" [showButtonBar]="true" [style]="{ width: '100%' }">
                  </p-calendar>
                </div>                
                <div class="form-group col-md-3 offset-1">
                  <label for="convenio">Convênio</label>
                  <p-autoComplete formControlName="convenio" [field]="convenioAutoComplete.conversor"
                    [suggestions]="convenioAutoComplete.lista" (completeMethod)="convenioAutoComplete.filtrar($event)"
                    inputStyleClass="form-control" minLength="2" [forceSelection]="true" [autoHighlight]="true" (onBlur)="obterSaldoConvenio()"
                    [style]="{ width: '100%' }" *ngIf="convenioAutoComplete">
                    <ng-template let-convenio pTemplate="item">
                      {{convenio.numero}}/{{convenio.ano}}
                    </ng-template>
                  </p-autoComplete>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="290px" imagem="assets/img/financial.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="col-md-12">
                  <label for="favorecido" style="display: block">Beneficiário<span class="text-danger">*</span></label>
                  <div class="form-group col-md-3 p-0 float-left">
                    <input class="form-control font-weight-bold" type="text"
                      (blur)="favorecidoAutoComplete.atualizar(false)" [(ngModel)]="favorecidoAutoComplete.id"
                      name="favorecido_id" [ngModelOptions]="{standalone: true}" *ngIf="favorecidoAutoComplete"
                      placeholder="código" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="favorecido" [field]="favorecidoAutoComplete.conversor"
                      [suggestions]="favorecidoAutoComplete.lista"
                      (completeMethod)="favorecidoAutoComplete.filtrar($event)"
                      placeholder="Informe cpf/cnpj ou nome/razão social"
                      inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                      (onSelect)="favorecidoAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                      *ngIf="favorecidoAutoComplete">
                      <ng-template let-favorecido pTemplate="item">
                        {{favorecido.cpf_cnpj | CPF}} {{favorecido.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-12">
                  <label for="ficha" style="display: block">Ficha de despesa<span class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="fichaAutoComplete.atualizar(false)"
                      [(ngModel)]="fichaAutoComplete.id" name="ficha_id" [ngModelOptions]="{standalone: true}"
                      *ngIf="fichaAutoComplete" placeholder="código" />
                  </div>
                  <div class="col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="ficha" [field]="fichaAutoComplete.conversor"
                      [suggestions]="fichaAutoComplete.lista" (completeMethod)="fichaAutoComplete.filtrar($event)"
                      placeholder="Informe a descrição do elemento da despesa" inputStyleClass="form-control"
                      minLength="2" [style]="{ width: '100%' }" (onSelect)="fichaAutoComplete.atualizar(true)"
                      (onBlur)="fichaAutoComplete.atualizar(true)" [forceSelection]="true" [autoHighlight]="true"
                      *ngIf="fichaAutoComplete">
                      <ng-template let-ficha pTemplate="item">
                        {{ ficha.numero }} - {{ficha.despesa.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="col-md-12">
                  <label for="subelemento" style="display: block">Subelemento da despesa<span
                      class="text-danger">*</span></label>
                  <div class="col-md-3 p-0 float-left">
                    <input class="form-control" type="text" (blur)="subElementoAutoComplete.atualizar(false)"
                      onfocus="let value = this.value; this.value = null; this.value=value"
                      [(ngModel)]="subElementoAutoComplete.id" name="subElemento_id"
                      [ngModelOptions]="{standalone: true}" unmask="unmask" [imask]="{mask: '0.0.00.00.00.000'}"
                      *ngIf="subElementoAutoComplete" placeholder="código" />
                  </div>
                  <div class="form-group col-md-9 p-0 float-left">
                    <p-autoComplete formControlName="subelemento" [field]="subElementoAutoComplete.conversor"
                      [suggestions]="subElementoAutoComplete.lista"
                      (completeMethod)="subElementoAutoComplete.filtrar($event)"
                      placeholder="Informe a descrição do subelemento" inputStyleClass="form-control" minLength="2"
                      [style]="{ width: '100%' }" (onSelect)="subElementoAutoComplete.atualizar(true)"
                      [forceSelection]="true" [autoHighlight]="true" *ngIf="subElementoAutoComplete">
                      <ng-template let-subElemento pTemplate="item">
                        {{subElemento.codigo}} - {{subElemento.nome}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="valor_empenho" class="font-weight-bold">Valor<span class="text-danger">*</span></label>
                  <input unmask="typed" [imask]="imaskConfig" formControlName="valor_empenho" type="text"
                    class="form-control text-right font-weight-bold" id="valor_empenho" placeholder="0,00">
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="form-row">
            <div class="col-12">
              <lib-divisor altura="180px" imagem="assets/img/video-conference.png" posicao="left"></lib-divisor>
              <div class="form-row">
                <div class="form-group col-md-6">
                  <label for="modalidade">Modalidade<span class="text-danger">*</span></label>
                  <select [compareWith]="compareFn" id="modalidade" formControlName="modalidade" class="form-control">
                    <option [ngValue]="item" *ngFor="let item of listaModalidades">
                      {{item.codigo}} - {{item.nome}}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label for="licitacao">Licitação</label>
                  <p-autoComplete formControlName="licitacao" [field]="licitacaoAutoComplete.conversor"
                    [suggestions]="licitacaoAutoComplete.lista" (completeMethod)="licitacaoAutoComplete.filtrar($event)"
                    inputStyleClass="form-control" minLength="2" [style]="{ width: '100%' }" [forceSelection]="true"
                    [autoHighlight]="true" *ngIf="licitacaoAutoComplete">
                    <ng-template let-licitacao pTemplate="item">
                      {{licitacao.numero}}
                    </ng-template>
                  </p-autoComplete>
                </div>

                <div class="form-group col-md-3">
                  <label for="ata">Ata</label>
                  <input formControlName="ata" type="text" class="form-control text-right" id="ata">
                </div>
              </div>
              <div class="form-row">
                <div class="form-group col-md-3">
                  <label for="documento">Documento</label>
                  <input formControlName="documento" type="text" class="form-control" id="documento">
                </div>

                
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card mt-2">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3">
                Dotação <span class="float-right">{{+dotacao | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Saldo anterior <span class="float-right">{{+anterior | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Reservado <span class="float-right">{{+reservado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3 font-weight-bold">
                Disponível <span class="float-right font-weight-bold">{{+anterior + +reservado + +(entidade.id ?
                  +entidade.valor_empenho : 0) - +empenhado - +entidadeForm.get('valor_empenho').value |
                  number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
          <div *ngIf="entidadeForm.get('contrato').value || entidadeForm.get('convenio').value " class="card mt-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3" *ngIf="entidadeForm.get('contrato').value">
                Saldo contrato <span class="float-right">{{+saldoContrato | number:'1.2-2'}}</span>
              </li>            
              <li class="list-group-item pl-3 pr-3" *ngIf="entidadeForm.get('convenio').value">
                Saldo convênio <span class="float-right">{{+saldoConvenio | number:'1.2-2'}}</span>
              </li>            
            </ul>
          </div>
          <div *ngIf="entidade.id" class="card mt-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3">
                Empenhado <span class="float-right">{{+empenhado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Liquidado <span class="float-right">{{+liquidado | number:'1.2-2'}}</span>
              </li>
              <li class="list-group-item pl-3 pr-3">
                Pago <span class="float-right">{{+pago | number:'1.2-2'}}</span>
              </li>
            </ul>
          </div>
          <div class="card mt-3">
            <ul class="list-group list-group-flush">
              <li class="list-group-item pl-3 pr-3">
                <div class="checkbox checbox-switch switch-danger">
                  <label>
                    <input formControlName="adiantamento" type="checkbox" />
                    <span></span>
                    Adiantamento
                  </label>
                </div>
              </li>
              <li class="list-group-item pl-3 pr-3">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input formControlName="fase4" type="checkbox" />
                    <span></span>
                    Enviado para fase IV
                  </label>
                </div>
              </li>
              <li class="list-group-item pl-3 pr-3">
                <div class="checkbox checbox-switch switch-primary">
                  <label>
                    <input formControlName="disponibilidade_anterior" type="checkbox" />
                    <span></span>
                    Disponibilidade anterior
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="form-row" *ngIf="entidadeForm.get('especie').value === 'EOA'">
        <div class="form-group col-12">
          <div class="row">
            <div class="col-12 mb-0">
              <span *ngIf="entidade" class="form-control-plaintext font-weight-bold" id="emp">
                EMPENHO Nº {{('00000' + entidade.numero).slice(-5) }}
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade" value="{{entidade.favorecido.cpf_cnpj | CPF}} {{entidade.favorecido.nome}}"
                readonly type="text" class="form-control-plaintext font-weight-bold" id="favorecido">
              <small *ngIf="entidade" class="form-text text-muted">{{entidade.favorecido.endereco}}</small>
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade" value="{{entidade.subelemento.codigo}} {{entidade.subelemento.nome}}" readonly
                type="text" class="form-control-plaintext" id="ficha">
            </div>
          </div>
          <div class="row">
            <div class="col-12 mb-0">
              <input *ngIf="entidade" value="{{entidade.ficha.acao.codigo}} {{entidade.ficha.acao.nome}}" readonly
                type="text" class="form-control-plaintext" id="acao">
            </div>
          </div>
        </div>
      </div>

      <br />
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="historico">Histórico<span class="text-danger">*</span></label>
          <button *ngIf="!entidade.id && entidadeForm.get('favorecido').value" data-toggle="modal"
            data-target="#dialogHistoricoFavorecido" class="btn btn-sm btn-link float-right">
            <em class="fa fa-history"></em> Históricos do Beneficiário
          </button>
          <textarea formControlName="historico" class="form-control" id="historico" rows="5"></textarea>
        </div>
      </div>
      <br>
      <button data-toggle="modal" data-target="#dialogUpload" type="button" class="btn btn-sm btn-outline-primary">
        Anexar arquivo e enviar
      </button>
      <div class="form-row mt-2" *ngIf="listaAnexos.length">
        <div class="col-12">
          <table class="table table-eddy">
            <thead>
              <tr style="height: 42px;">
                <th scope="col" class="text-left">Nome do arquivo</th>
                <th scope="col" class="text-left">Tipo</th>
                <th scope="col" class="text-left">Tamanho</th>
                <th scope="col" class="text-center">#</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of listaAnexos">
                <td style="width: 50%;" class="text-left">{{item.nome}}</td>
                <td style="width: 30%;" class="text-left">{{item.tipo}}
                <td style="width: 110px;" class="text-left">{{item.tamanho}}</td>
                <td style="width: 110px;" class="text-center">
                  <a href="javascript:void" (click)="download(item)">
                    <img src="assets/img/global/download_cloud.png" alt="cvs" title="download" height="22" width="22">
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="salvar" title="Salvar e novo" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>

<lib-empenho-anulacao *ngIf="entidade.id" [login]="login" [empNumero]="entidade.numero" [empenhoId]="entidade.id">
</lib-empenho-anulacao>
<lib-historico-favorecido *ngIf="!entidade.id && entidadeForm.get('favorecido').value" [login]="login"
  [favorecido]="entidadeForm.get('favorecido').value['id']" (callback)="entidadeForm.get('historico').setValue($event)">
</lib-historico-favorecido>

<div class="modal fade" id="dialogUpload" tabindex="-1" role="dialog" aria-labelledby="uploadArquivo"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="exampleModalLongTitle">Enviar arquivo e salvar</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form enctype="multipart/form-data">
          <p-fileUpload #fileUpload customUpload=true (uploadHandler)="onUpload($event, fileUpload)" chooseLabel="Selecionar"
            uploadLabel="Enviar" cancelLabel="Cancelar" multiple="multiple" accept=".pdf,.csv,.xml,.png,.xls,.xlsx,.odt"
            maxFileSize="1000000000">
            <ng-template pTemplate="content">
              <ul *ngIf="uploadedFiles.length">
                <li *ngFor="let file of uploadedFiles">{{file.name}} - {{file.size}} bytes</li>
              </ul>
            </ng-template>
          </p-fileUpload>
        </form>
      </div>
      <div class="modal-footer">
        <button #btnCancelarUpload type="button" class="btn btn-secondary" id="btnCancelarUpload"
          data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>

<app-empenho-item *ngIf="entidadeForm.get('compra').value" [id]="entidadeForm.get('compra').value['id']">
</app-empenho-item>